import { Box, Link, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReputationPlusLogo from '../../assets/images/logos/reputationplus.png';

interface Props {
  copyrightText: string | null;
  companyName: string;
  imprintLink: string;
  contactEmail: string;
  privacyPolicyLink: string;
}

const TrustpageFooter = ({
  copyrightText,
  companyName,
  imprintLink,
  privacyPolicyLink,
  contactEmail,
}: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isSmallScreen = useMediaQuery(theme.breakpoints.up('md'));

  const useSpaceBetween = copyrightText || contactEmail || imprintLink || privacyPolicyLink;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        mt: 'auto',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: isSmallScreen ? 'row' : 'column',
          justifyContent: useSpaceBetween ? 'space-between' : 'center',
          alignItems: 'center',
          gap: theme.spacing(1),
          minWidth: 'auto',
          maxWidth: '1366px',
          width: '100%',
          borderTop: `1px solid ${theme.palette.divider}`,
          px: theme.spacing(3),
          py: theme.spacing(2),
        }}
      >
        <Typography variant="caption">{`© ${new Date().getFullYear()} ${companyName}`}</Typography>
        {(contactEmail || imprintLink || privacyPolicyLink) && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
            {contactEmail && (
              <>
                <Link
                  variant="caption"
                  href={`mailto:${contactEmail}`}
                  underline="none"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t('contact_label')}
                </Link>
                {imprintLink && <Typography variant="caption">|</Typography>}
              </>
            )}
            {imprintLink && (
              <>
                <Link
                  variant="caption"
                  href={imprintLink}
                  underline="none"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t('imprint')}
                </Link>
                {privacyPolicyLink && <Typography variant="caption">|</Typography>}
              </>
            )}
            {privacyPolicyLink && (
              <Link
                variant="caption"
                href={privacyPolicyLink}
                underline="none"
                target="_blank"
                rel="noreferrer"
              >
                {t('privacy')}
              </Link>
            )}
          </Box>
        )}
        <Box
          sx={{
            minWidth: 250,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: theme.spacing(1),
          }}
        >
          <Typography variant="caption">Powered by:</Typography>
          <Link
            href={process.env.REACT_APP_REPUTATIONPLUS_WEBSITE_URL || 'https://reputation.plus'}
            underline="none"
            target="_blank"
            rel="noreferrer"
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <img
              src={ReputationPlusLogo}
              style={{
                maxHeight: '24px',
              }}
              alt="Reputativ Logo"
            />
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default TrustpageFooter;
